import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  DialogStyles: {
    '& .MuiPaper-root': {
      overflow: 'hidden',
    }
  }
}))
